import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import DefaultTeamStar from 'app/frontend/base/components/DefaultTeamStar'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import {
  LinkedTeamGroup,
  linkedTeamHref,
} from 'app/frontend/base/helpers/linkedGuilds'
import NewsTagBadge from 'app/frontend/base/pages/News/NewsTagBadge'

const LinkedTeamsMenuGroups = ({ groups }: { groups: LinkedTeamGroup[] }) => {
  const navigate = useNavigate()
  const { customDomain } = useCustomDomain()

  return groups.map(({ linkedGuild, teams, isOtherGameVersion }) => (
    <Fragment key={linkedGuild.id}>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className='flex items-center justify-between gap-3 text-xs font-medium text-muted-foreground'>
        <span className='truncate'>{linkedGuild.name}</span>
        {isOtherGameVersion ? (
          <NewsTagBadge tag={linkedGuild.gameVersion} />
        ) : null}
      </DropdownMenuLabel>

      {teams.map((team) => {
        const href = linkedTeamHref(team, {
          isOtherGameVersion,
          onCustomDomain: !!customDomain,
        })

        return (
          <DropdownMenuItem
            key={team.id}
            onSelect={() =>
              'external' in href
                ? window.location.assign(href.external)
                : navigate(href.internal)
            }
          >
            <span className='flex w-full items-center justify-between gap-4'>
              <span className='flex items-center gap-1.5'>
                {team.default ? <DefaultTeamStar /> : null}
                <span>{team.name}</span>
              </span>
              {'external' in href ? (
                <ExternalLink size={12} className='text-muted-foreground' />
              ) : null}
            </span>
          </DropdownMenuItem>
        )
      })}
    </Fragment>
  ))
}

export default LinkedTeamsMenuGroups
